import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loadOfferCopies } from '../../lib/duplicate';
import { apiError } from '../../lib/utils';
import { Alert } from '../ui/Badge';
import { Button } from '../ui/Button';
import { Dialog } from '../ui/Dialog';
import { useNotice } from '../ui/Notice';

export function OfferDuplicateDialog({ proposalId, quotationId, onClose }: { proposalId?: string; quotationId?: string; onClose: () => void }) {
  const navigate = useNavigate();
  const notice = useNotice();
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function go(which: 'proposal' | 'quotation' | 'both') {
    setBusy(true);
    setError('');
    try {
      const copies = await loadOfferCopies(proposalId, quotationId, which);
      onClose();
      navigate('/sales-offers/new', { state: copies });
      notice.success('Duplicated');
    } catch (err) {
      notice.failure(apiError(err, 'Could not duplicate'));
      setBusy(false);
    }
  }

  return (
    <Dialog title="Duplicate offer" onClose={onClose} footer={<Button variant="outline" onClick={onClose}>Cancel</Button>}>
      {error ? <Alert error>{error}</Alert> : null}
      <p className="text-sm text-[var(--bo-muted)]">Choose what to copy. Nothing is saved until you save. The offer name is left blank. The document number is assigned when you save.</p>
      <div className="flex flex-wrap gap-2">
        <Button disabled={busy || !proposalId} onClick={() => void go('proposal')}>Proposal</Button>
        <Button disabled={busy || !quotationId} onClick={() => void go('quotation')}>Quotation</Button>
        <Button disabled={busy || !proposalId || !quotationId} onClick={() => void go('both')}>Both</Button>
      </div>
    </Dialog>
  );
}
